import { useTranslation } from "react-i18next";

import AccountCard from "./AccountCard";
import PreferencesCard from "./PreferencesCard";

export default function ProfilePage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-5xl py-6">
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
          {t("profile.title")}
        </h1>
        <p className="mt-1 text-sm text-gray-600">{t("profile.subtitle")}</p>
      </header>
      <div className="space-y-6">
        <AccountCard />
        <PreferencesCard />
      </div>
    </div>
  );
}
